import { render } from "./DetalharOperadorPagamento.vue?vue&type=template&id=5097078b&scoped=true"
import script from "./DetalharOperadorPagamento.vue?vue&type=script&lang=js"
export * from "./DetalharOperadorPagamento.vue?vue&type=script&lang=js"

import "./DetalharOperadorPagamento.vue?vue&type=style&index=0&id=5097078b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5097078b"]])

export default __exports__